module.exports = __webpack_public_path__ + "static/img/image062.5c81a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image062.png
// module id = ZfoK
// module chunks = 1